var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.103,
    height: 5.847,
    viewBox: "0 0 10.103 5.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow_down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.05,1.763l-3.82,3.87a.713.713,0,0,1-1.02,0A.743.743,0,0,1,.21,4.6L4.538.213a.714.714,0,0,1,1-.021l4.358,4.4a.741.741,0,0,1,0,1.035.713.713,0,0,1-1.02,0Z",
    transform: "translate(10.103 5.847) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.ba142ebe13825fc988a2dc4147685217.svg";
export { ForwardRef as ReactComponent };